enum EVENT_STATUS {
  APPROVED = 'APPROVED',
  REQUESTED = 'REQUESTED',
  REJECTED = 'REJECTED',
  ACTION_REQUIRED = 'ARCHIVE',
  DISCARD = 'Discard',
}

export { EVENT_STATUS };
